var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1079.5,
    fill: "#EEE7E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1038.11 626.111C613.718 546.964 268.424 620.536 0 668.238V961.883L1920 991V540C1805.31 592.658 1476.58 707.886 1038.11 626.111Z",
    fill: "#EEE7E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M793.279 677.384C396.885 755.829 240.984 725.464 0 677.384V1019H1920V604C1751.8 815.929 1124.26 611.883 793.279 677.384Z",
    fill: "#D9C7C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M861.096 740.729C720.298 773.874 252.128 847.959 0.106807 762.226L0.0479974 990.273L1919.42 990.768L1919.48 741.001C1829.39 752.441 1682.48 791.014 1442.46 790.952C1349.91 790.928 1011.34 705.359 861.096 740.729Z",
    fill: "#BFA59B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M856.982 824.961C537.553 944.948 258.84 873.203 0 837.949V1021.64L1919 1047V888.665C1697.97 978.347 1124.55 724.455 856.982 824.961Z",
    fill: "#A67E6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.89 1000.52C901.954 926.874 221.631 847.721 0 1010.28V1080H1920V934.157C1802.87 952.038 1406.82 1062.12 1176.89 1000.52Z",
    fill: "#A6774E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBrown);
export default __webpack_public_path__ + "static/media/bgBrown.1ba981436ed2dc171a6a15749ff136f6.svg";
export { ForwardRef as ReactComponent };